/**
 * LT2-006 on Game Detail: the line a hotkey card fires at must be the line
 * the trader aimed at, not whichever line is nearest 50¢ a moment later.
 *
 * Game Detail's spread/total cards keep one card id per event and kind (no
 * line in it) and show a default line until a chip pins another: the
 * closest-to-50¢ line, or with #1071's initial-line switch on a line settled
 * once (the board's, or the busiest near 50¢).
 * Aiming by clicking the row (the path the header readout teaches) pinned
 * nothing, so the selection kept re-centring as prices moved and A, D and S
 * fired on a strike the trader never chose. The dashboard board is immune:
 * it seeds its line keys once.
 *
 * This pins the DISPLAYED line's key the moment the card acquires hotkey
 * focus, whatever gesture aimed it. Only on acquisition, and only when no
 * key is pinned yet, so the unaimed view keeps its default and a chip pick
 * is never overridden.
 */
import { useLayoutEffect } from 'react';
import { useLt2FocusStore } from '@/stores/lt2FocusStore';

export function usePinLineOnAim(args: {
  /** LT2 access and a card id: off, the hook does nothing. */
  cardId: string | null;
  /** The key already pinned (a chip pick or deep link), or null. */
  pinnedKey: string | null;
  /** The key of the line on screen right now. */
  displayedKey: string | null;
  pin: (key: string) => void;
}): void {
  const { cardId, pinnedKey, displayedKey, pin } = args;
  const focused = useLt2FocusStore((s) => cardId != null && s.focusedCardId === cardId);
  useLayoutEffect(() => {
    if (focused && pinnedKey == null && displayedKey != null) pin(displayedKey);
    // Acquisition is the trigger; displayedKey is read at that moment.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focused]);
}
